import { FormatRegistry } from "@sinclair/typebox";
import { Value } from "@sinclair/typebox/value";
import addFormats from "ajv-formats";
import {
  USER_AUTOMATION_ROOT_KEY,
  UserAutomationRootSchema,
  type UserAutomationRoot,
  type UserAutomationResult
} from "./user-automation.ts";
import { AGENT_MESSAGE_KEY } from "./agent-message.ts";

// Interpret the schema in renderers without weakening their no-eval CSP.
const timestampFormat = addFormats.get("date-time", "full");
if (
  typeof timestampFormat !== "object" ||
  !("validate" in timestampFormat) ||
  timestampFormat.type === "number" ||
  typeof timestampFormat.validate !== "function"
)
  throw new Error("DATE_TIME_FORMAT_INVALID");
const validateTimestamp = timestampFormat.validate as (value: string) => unknown;
FormatRegistry.Set("date-time", (value) => validateTimestamp(value) === true);

export interface AutomationRootEvent {
  roomId: string | undefined;
  eventId: string | undefined;
  sender: string | undefined;
  type: string;
  redacted: boolean;
  content: Record<string, unknown>;
}

export function verifiedUserAutomationRoot(
  event: AutomationRootEvent,
  trustedDirectChat: { roomId: string; botMxid: string; agentKey: string; humanMxid: string }
): UserAutomationRoot | null {
  const { content } = event;
  const root: unknown = content[USER_AUTOMATION_ROOT_KEY];
  if (
    !event.eventId ||
    event.roomId !== trustedDirectChat.roomId ||
    event.sender !== trustedDirectChat.botMxid ||
    !trustedDirectChat.humanMxid ||
    trustedDirectChat.humanMxid === trustedDirectChat.botMxid ||
    event.type !== "m.room.message" ||
    event.redacted ||
    content.msgtype !== "m.text" ||
    typeof content.body !== "string" ||
    content["m.relates_to"] !== undefined ||
    content[AGENT_MESSAGE_KEY] !== undefined ||
    !Value.Check(UserAutomationRootSchema, root)
  )
    return null;
  const value = root as UserAutomationRoot;
  return value.agentKey === trustedDirectChat.agentKey ? value : null;
}

export function userAutomationResultMatchesRoot(
  result: UserAutomationResult | undefined,
  root: UserAutomationRoot
): boolean {
  return (
    !result ||
    (result.automationId === root.automationId &&
      result.revision === root.revision &&
      result.scheduledAt === root.scheduledAt)
  );
}
